import { ProductApiService } from '@/core/services';
import { Component, inject } from '@angular/core';
import { ButtonClickEvent, CacBaseDialogComponent, CacButtonComponent, CacDialogLayoutComponent, CacTableComponent, DataGetResponse, table } from '@controladad/ng-base';
import { ProductEntity } from '@repo/types';


export interface ProductListDialogData {
    selectedIds: number[];
}

export interface ProductListDialogResult {
    products: ProductEntity[];
};

@Component({
    selector: 'feature-product-list-dialog',
    standalone: true,
    imports: [CacDialogLayoutComponent, CacTableComponent],
    templateUrl: './product-list-dialog.component.html',
    styleUrl: './product-list-dialog.component.scss',
})
export class ProductListDialogComponent extends CacBaseDialogComponent<ProductListDialogData, ProductListDialogResult> {
    private readonly productApi = inject(ProductApiService);

    table = table({
        itemsFn: this.productApi.getAdapter(),
        selectable: true,
        columns: {
            id: { label: 'ID', filterable: true },
            name: {
                label: 'Product Name',
                filterable: [
                    {
                        type: 'contains',
                        key: 'Name',
                    }
                ],
            },
        },
        events: {
            response: (e) => {
                const selectedProducts = (e as DataGetResponse<ProductEntity>).data.filter(x => this.data.selectedIds.includes(x.id)) || [];
                this.table.ref?.options()?.selectionModel?.select(...selectedProducts);
            },
        }
    });

    onSubmit(e: ButtonClickEvent) {
        const selectedProducts = this.table.ref?.options()?.selectionModel?.selected() || [];
        if (!selectedProducts.length) {
            snackbar$.error('There is no selected product.');
            return;
        }
        this.submit({ products: selectedProducts }, e.pipe());
    }
}
